import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Grid } from '@material-ui/core';
import { GraphAutocomplete } from 'components/GraphAutocomplete';
import { useDispatch, useSelector } from 'react-redux';
import { GraphGroupUser } from 'redux/models/graphGroupUser';
import { RootStore } from 'redux/store';
import { ModalWrapper } from '..';
import { addMembersToTeam as addMembersToTeamThunk } from 'redux/thunks';
import { resetAddTeamMembersCompleteValue } from 'redux/actions';
import './AddTeamMembersModal.scss';

interface AddTeamMembersProps {
	teamId: string;
	userId: string;
	open: boolean;
	teamName: string;
	onCloseClicked: () => void;
	allowClickOutsideToClose?: boolean;
}

const AddTeamMembersModal: React.FC<AddTeamMembersProps> = (props: AddTeamMembersProps) => {
	const dispatch = useDispatch();
	const team = useSelector((state: RootStore) => state.team);
	const { teamId, userId, open, teamName, onCloseClicked, allowClickOutsideToClose } = props;
	const [users, setUsers] = useState<GraphGroupUser[]>([]);

	const selectUser = (users: any) => {
		setUsers(users);
	};

	const saveChanges = (event: any) => {
		event.preventDefault();
		dispatch(addMembersToTeamThunk(teamId, users));
	};

	useEffect(() => {
		if (team.addMembersComplete) {
			dispatch(resetAddTeamMembersCompleteValue());
			onCloseClicked();
		}
	}, [team.addMembersComplete, dispatch, onCloseClicked]);

	return (
		<ModalWrapper open={open} onCloseClicked={onCloseClicked} allowClickOutsideToClose={allowClickOutsideToClose}>
			<form onSubmit={saveChanges} style={{width: '100%'}}>
				<Box display="flex"  alignItems="center" alignContent="center" flexDirection="column" className="add-team-member-box-layout">
					<div className="add-team-member-header">Add Members to {teamName}</div>

					<Grid container item className='add-team-member-container'>
						<Grid container item justify="space-around">
							<Grid item xs={10} sm={10}>
								<GraphAutocomplete currentUserId={userId} onSelectUser={selectUser} tagLimit={2}></GraphAutocomplete>
							</Grid>
						</Grid>
						<Grid className="form-action-buttons" container item justify="flex-end" alignItems="flex-end">
							<Grid item>
								<Button color="primary" className="add-team-member-back-button" onClick={onCloseClicked}>
									cancel
								</Button>
							</Grid>
							<Grid item className="add-team-member-button">
								<Button type="submit" variant="contained" color="primary" disabled={team?.addingTeamMembers}>
									Save Changes
									{team?.addingTeamMembers && <CircularProgress size={24} className="buttonProgress" />}
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</form>
		</ModalWrapper>
	);
};

export default AddTeamMembersModal;
